import React from "react";

const WalletLoader = () => {
  return (
    <div className="space-y-6 animate-pulse">
      {/* Wallet Card Skeleton */}
      <div className="relative bg-gradient-to-br from-blue-600 via-blue-700 to-purple-600 rounded-2xl p-6 text-white shadow-xl overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>

        <div className="relative flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="flex-1">
            <div className="h-4 w-28 bg-white/30 rounded mb-3"></div>
            <div className="h-10 w-40 bg-white/40 rounded mb-2"></div>
            <div className="h-3 w-60 bg-white/20 rounded"></div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <div className="h-10 w-32 bg-white/30 rounded"></div>
          </div>
        </div>
      </div>

      {/* Auto Recharge Skeleton */}
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-2xl p-6 shadow-sm">
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-3">
            <div className="h-8 w-8 bg-gray-200 dark:bg-gray-700 rounded-lg"></div>
            <div>
              <div className="h-4 w-32 bg-gray-200 dark:bg-gray-700 rounded mb-2"></div>
              <div className="h-3 w-44 bg-gray-200 dark:bg-gray-700 rounded"></div>
            </div>
          </div>
          <div className="h-6 w-12 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
        </div>

        <div className="space-y-4">
          <div className="h-10 w-full bg-gray-200 dark:bg-gray-700 rounded-lg"></div>
          <div className="h-10 w-full bg-gray-200 dark:bg-gray-700 rounded-lg"></div>
          <div className="h-20 w-full bg-gray-100 dark:bg-gray-700 rounded-lg"></div>
        </div>
      </div>
    </div>
  );
};

export default WalletLoader;
